import React from 'react';
import { RouteConfig } from 'react-router-config';

const AIChat = React.lazy(() => import('@/page/ai-app/ai-chat'));

const AgentChatLayout = React.lazy(
  () => import('@/page/layout/agent-chat-layout')
);

const AiseeList = React.lazy(() => import('@/page/ai-app/aisee-list'));
const Skills = React.lazy(() => import('@/page/ai-app/skills'));
const Automation = React.lazy(() => import('@/page/ai-app/automation'));
const Knowledge = React.lazy(() => import('@/page/ai-app/knowledge'));

const ROUTES: RouteConfig[] = [
  {
    path: '/admin/:lv1product/:lv2product/:lv3product/aiSeeAssistant',
    component: AgentChatLayout,
    routes: [
      {
        // 空白 /task 和 /task/:sessionId 必须是同一条路由。
        // 拆成两条时，第一句 history.replace 会卸掉聊天页，useSendMessage 卸载把 SSE abort 掉。
        path: '/admin/:lv1product/:lv2product/:lv3product/aiSeeAssistant/task/:sessionId?',
        exact: true,
        component: AIChat,
      },
      {
        path: '/admin/:lv1product/:lv2product/:lv3product/aiSeeAssistant/aiseeList',
        exact: true,
        component: AiseeList,
      },
      {
        path: '/admin/:lv1product/:lv2product/:lv3product/aiSeeAssistant/automation',
        exact: true,
        component: Automation,
      },
      {
        path: '/admin/:lv1product/:lv2product/:lv3product/aiSeeAssistant/skills',
        exact: true,
        component: Skills,
      },
      {
        path: '/admin/:lv1product/:lv2product/:lv3product/aiSeeAssistant/knowledge',
        exact: true,
        component: Knowledge,
      },
    ],
  },
];

export default ROUTES;
